import VirtualPortalHeader from './VirtualPortalHeader'

export default VirtualPortalHeader